
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/[slug]",
      function () {
        return require("private-next-pages/guides/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/[slug]"])
      });
    }
  